"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
var React = _interopRequireWildcard(require("react"));
var _hooks = require("./hooks");
var _StaticTable = require("./StaticTable");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// type ClassNames = $ReadOnly<{wrapper?: string}>;

/**
 * Table
 * @param {React.ComponentType} Row - React.ComponentType<{data: Data, extras?: Extras, sortedKeys?: string[]}>
 * @param {string} className - string
 *
 **/

/**
 * Table
 * @param {React.ComponentType} Row - React.ComponentType<{data: Data, extras?: Extras, sortedKeys?: string[]}>
 * @param {string} className - string
 *
 */
function Table(props) {
  const {
    // @ts-ignore - TS6133 - 'className' is declared but its value is never read.
    className,
    // @ts-ignore - TS6133 - 'classNames' is declared but its value is never read.
    classNames,
    // @ts-ignore - TS6133 - 'TableRow' is declared but its value is never read.
    TableRow,
    entries,
    // @ts-ignore - TS6133 - 'extras' is declared but its value is never read.
    extras,
    // @ts-ignore - TS6133 - 'headers' is declared but its value is never read.
    headers,
    // @ts-ignore - TS6133 - 'showHeader' is declared but its value is never read.
    showHeader = true,
    // @ts-ignore - TS6133 - 'tableHeaderClassName' is declared but its value is never read.
    tableHeaderClassName,
    sortable = true,
    defaultSortKey,
    defaultSortDirection = 'original',
    onSort,
    enableInternalSorting,
    // @ts-ignore - TS6133 - 'isLoading' is declared but its value is never read.
    isLoading,
    idName = 'id',
    // @ts-ignore - TS6133 - 'emptyText' is declared but its value is never read.
    emptyText,
    virtualizationOptions
  } = props;

  /**
   *
   */

  const {
    sortedEntries,
    sortedKeys,
    ...sortableProps
  } = (0, _hooks.useSortableEntries)(entries, idName, {
    defaultSortKey,
    defaultSortDirection,
    onSort,
    enableInternalSorting
  });
  const virtualized = !!(virtualizationOptions && virtualizationOptions.rowsCount > 0);
  return virtualized ? /*#__PURE__*/React.createElement(_StaticTable.StaticTableVirtualized, _extends({}, props, sortableProps, {
    sortable: sortable,
    entries: sortedEntries
    // @ts-ignore - TS2322 - Type 'keyof T[]' is not assignable to type 'string[] | undefined'.
    ,
    rowKeys: sortedKeys
  })) : /*#__PURE__*/React.createElement(_StaticTable.StaticTable, _extends({}, props, sortableProps, {
    sortable: sortable,
    entries: sortedEntries
    // @ts-ignore - TS2322 - Type 'keyof T[]' is not assignable to type 'string[] | undefined'.
    ,
    rowKeys: sortedKeys
  }));
}